import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import "./Dashcampanha.css";
import PrivateMenuLeft from "../../sections/Header/privateMenuLeft";
import PrivateMenuUp from "../../sections/Header/privateMenuUp";
import PrivateMenuCampanha from "./privateMenuCampanha";
import { useParams } from "react-router-dom";
import useAuth from "../../../../components/hooks/useAuth";
import Loader from "../../../../components/Loader";
import { Helmet } from "react-helmet";

const HEADER_HEIGHT = 56;

// Opções de períodos solicitadas: 7, 14, 30, 60, 90 dias
const PAGE_OPTIONS = [7, 14, 20, 30, 60, 90];

const Dashcampanha = () => {
  const { id: campaignId } = useParams();
  const { sidebarOpen, getApi, postApi, deleteApi } = useAuth();
  const [campaignLink, setCampaignLink] = useState(null);
  const [loading, setLoading] = useState(false);
  const [campaignName, setCampaignName] = useState(null);
  const [campaignQtdGroups, setCampaignQtdGroups] = useState(0);
  const [campaignQtdMembers, setCampaignQtdMembers] = useState(0);
  const [campaignQtdMembersLife, setCampaignQtdMembersLife] = useState(0);
  const [aliveCampaign, setAliveCampaign] = useState(false);
  const [defaultGroup, setDefaultGroup] = useState([]);
  const [qtdAccessLink, setQtdAccessLink] = useState(0);
  const [qtdUniqueAccessLink, setQtdUniqueAccessLink] = useState(0);
  const [qtdClicksUnique, setQtdClicksUnique] = useState(0);
  const [qtdClicks, setQtdClicks] = useState(0);
  const [campaignQtdFullGroups, setCampaignQtdFullGroups] = useState(0);

  const [loadingResetHashLink, setLoadingResetHashLink] = useState(false);
  const [showConfigMenu, setShowConfigMenu] = useState(false);
  const [loadingUpConfigBasis, setLoadingUpConfigBasis] = useState(false);

  // Configurações de Switch
  const [autoRevoke, setAutoRevoke] = useState(true);
  const [deepLinking, setDeepLinking] = useState(true);
  const [autoUpdateLinks, setAutoUpdateLinks] = useState(true);
  const [antiHacker, setAntiHacker] = useState(true);
  const [redirectCookie, setRedirectCookie] = useState(true);


  const [statsMemberIn, setStatsMemberIn] = useState([]);
  const [statsMemberOut, setStatsMemberOut] = useState([]);

  const [statsLinkClick, setStatsLinkClick] = useState([]);
  const [statsLinkCount, setStatsLinkCount] = useState([]);

  // Cores Notify
  const notifyColor = "#51a197";

  // Estado para filtros de dias individual por gráfico de histórico
  // Atualizado para as novas chaves solicitadas
  const [daysRange, setDaysRange] = useState({
    "Entraram no grupo": 7,
    "Sairam do grupo": 7,
    "Entraram no link": 7,
    "Clicaram": 7,
  });

  const chartData = [
    { title: "Entraram", value: campaignQtdMembersLife, color: "#28c76f", icon: "bi bi-person-plus" },
    { title: "Sairam", value: campaignQtdMembersLife - campaignQtdMembers, color: "#ea5455", icon: "bi bi-person-dash" },
    {
      title: "Percentual de entrada",
      value: qtdAccessLink > 0 ? parseFloat((campaignQtdMembersLife / qtdAccessLink) * 100).toFixed(2) : 0,
      color: notifyColor,
      icon: "bi bi-graph-up-arrow"
    },
    { title: "Cliques", value: qtdClicks, color: "#ff9f43", icon: "bi bi-mouse" },
    { title: "Participantes", value: campaignQtdMembers, color: "#7367f0", icon: "bi bi-people" },
    { title: "Grupos", value: campaignQtdGroups, color: "#00cfe8", icon: "bi bi-collection" },
    { title: "Grupos cheios", value: campaignQtdFullGroups, color: "#ff6384", icon: "bi bi-check-circle" },
    { title: "Grupos disponíveis", value: campaignQtdGroups - campaignQtdFullGroups, color: "#00e096", icon: "bi bi-plus-circle" },
  ];

  // Estrutura de Séries para Histórico (Mantenha a lógica de alimentação via API aqui)
  const chartSeries = {
    "Entraram no grupo": statsMemberIn,
    "Sairam do grupo": statsMemberOut,
    "Entraram no link": statsLinkCount,
    "Clicaram": statsLinkCount,
  };

  const chartColors = {
    "Entraram no grupo": "#28c76f",
    "Sairam do grupo": "#ea5455",
    "Entraram no link": notifyColor,
    "Clicaram": "#ff9f43",
  };

  useEffect(() => {
    loadCampaignRequest();

    new Date()

    getStatsMembers('in', getDataFromDays(90), getDataFromDays(0))
    getStatsMembers('out', getDataFromDays(90), getDataFromDays(0))


    getStatsLink('click-count', getDataFromDays(90), getDataFromDays(0))
    getStatsLink('access-count', getDataFromDays(90), getDataFromDays(0))
  }, [campaignId]);

  const getDataFromDays = (diasAtras) => {
    const hoje = new Date(); // Data atual

    // Data Inicial (hoje - dias)
    const dataInicial = new Date();
    dataInicial.setDate(hoje.getDate() - diasAtras);

    return dataInicial.toISOString().split('T')[0];
  }

  const loadCampaignRequest = async () => {
    setLoading(true);
    try {
      let response = await getApi("/api/v1/campaign/show/" + campaignId, {});
      setData(response);
    } catch (error) {
      console.error("Erro ao processar:", error);
    } finally {
      setLoading(false);
    }
  };

  const setData = async (campaign) => {
    setCampaignLink(campaign.hash_link);
    setCampaignName(campaign.name);
    setCampaignQtdGroups(campaign.qtd_groups);
    setCampaignQtdMembers(campaign.qtd_members);
    setCampaignQtdMembersLife(campaign.qtd_members_life);
    setAliveCampaign(campaign.alive);
    setDefaultGroup(campaign.default_group);
    setQtdClicks(campaign.qtd_clicks);
    setQtdClicksUnique(campaign.qtd_unique_clicks);
    setQtdAccessLink(campaign.qtd_accesslink);
    setQtdUniqueAccessLink(campaign.qtd_unique_accesslink);
    setCampaignQtdFullGroups(campaign.qtd_full_groups);

    setDeepLinking(campaign.deep_link_auto_entry);
    setAutoRevoke(campaign.invite_link_revoke_on_full);
    setRedirectCookie(campaign.redirect_cookie_first_group);
    setAntiHacker(campaign.anti_hacker_remove_on_closed);
    setAutoUpdateLinks(campaign.invite_link_update_on_ban);
  };


  const getStatsMembers = async (operation, start_date, end_date) => {
    try {
      let response = await getApi("/api/v1/campaign/stats/members/" + operation + "/" + campaignId + "/" + start_date + "/" + end_date, {});
      if (response) {
        if (operation == 'in') {
          setStatsMemberIn(response);
        } else {
          setStatsMemberOut(response);
        }
      }


    } catch (error) {
      window.alert("Erro ao redefinir link:", error);
    } finally {
    }
  };

  const getStatsLink = async (operation, start_date, end_date) => {
    try {
      let response = await getApi("/api/v1/campaign/stats/" + operation + "/" + campaignId + "/" + start_date + "/" + end_date, {});
      if (response) {
        if (operation == 'click-count') {
          setStatsLinkClick(response);
        } else {
          setStatsLinkCount(response);
        }
      }

    } catch (error) {
      window.alert("Erro ao redefinir link:", error);
    } finally {
    }
  };



  const updateHashLink = async () => {
    if (!window.confirm("Isso vai redefinir o link da campanha.\nDeseja prosseguir ?")) return;
    setLoadingResetHashLink(true);
    try {
      let response = await postApi("/api/v1/campaign/update/hashlink/" + campaignId, {});
      setData(response);
    } catch (error) {
      window.alert("Erro ao redefinir link:", error);
    } finally {
      setLoadingResetHashLink(false);
    }
  };

  const updateConfig = async (variable, value) => {
    setLoadingUpConfigBasis(true);
    try {
      let params;
      if (variable === 'redirectCookie') { setRedirectCookie(value); params = { 'redirect_cookie_first_group': value }; }
      if (variable === 'autoRevoke') { setAutoRevoke(value); params = { 'invite_link_revoke_on_full': value }; }
      if (variable === 'deepLinking') { setDeepLinking(value); params = { 'deep_link_auto_entry': value }; }
      if (variable === 'autoUpdateLinks') { setAutoUpdateLinks(value); params = { 'invite_link_update_on_ban': value }; }
      if (variable === 'antiHacker') { setAntiHacker(value); params = { 'anti_hacker_remove_on_closed': value }; }
      await postApi("/api/v1/campaign/update/config/" + campaignId, params);
    } catch (error) {
      window.alert("Erro ao atualizar configuração:", error);
    } finally {
      setLoadingUpConfigBasis(false);
    }
  };

  return (
    <div className="modern-dashboard-container">
      <Helmet>
        <title>{`Campanha - ${campaignName || 'Carregando...'}`}</title>
      </Helmet>
      <PrivateMenuLeft />
      <PrivateMenuUp />

      <div
        style={{
          marginLeft: window.innerWidth <= 768 ? 56 : sidebarOpen ? 220 : 70,
          paddingTop: HEADER_HEIGHT,
          width: window.innerWidth <= 768 ? "calc(100vw - 56px)" : sidebarOpen ? "calc(100% - 220px)" : "calc(100% - 70px)",
          transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
          paddingRight: "20px",
          paddingLeft: "20px"
        }}
      >
        <PrivateMenuCampanha />

        {loading && <Loader />}

        <div style={{ display: loading ? "none" : "unset" }}>
          {/* Cards de Indicadores Topo */}
          <div className="stats-grid">
            {chartData.map((item, index) => (
              <div key={index} className="dash-card">
                <div className="stat-card-content">
                  <div className="stat-icon-wrapper" style={{ color: item.color, background: `${item.color}15` }}>
                    <i className={item.icon}></i>
                  </div>
                  <div className="stat-info-wrapper">
                    <span className="stat-value">{item.title === "Percentual de entrada" ? `${item.value}%` : item.value}</span>
                  </div>
                  <span className="stat-label">{item.title}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Card de Informação e Convite */}
          <div className="info-invite-container">
            <div className="campaign-header-card">
              <div className="campaign-title-section">
                <small>Campanha</small>
                <h2>{campaignName}</h2>
              </div>
              <div className="campaign-info-row">
                <div className="campaign-info-group">
                  <div className="detail-icon"><i className="bi bi-people-fill"></i></div>
                  <div className="detail-texts">
                    <span className="label">Grupo Padrão</span>
                    <span className="value-truncate" title={defaultGroup?.name}>{defaultGroup?.name || "Nenhum grupo"}</span>
                  </div>
                </div>
                <div className="campaign-actions-group">
                  <div className={`status-badge ${aliveCampaign ? 'active' : 'inactive'}`}>
                    <span className="status-dot"></span>
                    {aliveCampaign ? "Ativa" : "Inativa"}
                  </div>
                  <div className="config-wrapper">
                    <button className="btn-config" onClick={() => setShowConfigMenu(!showConfigMenu)}>
                      <i className="bi bi-gear-fill"></i> Configurar <i className={`bi bi-chevron-${showConfigMenu ? 'up' : 'down'}`}></i>
                    </button>
                    {showConfigMenu && (
                      <div className="dropdown-menu-custom">
                        <button className="dropdown-item" onClick={() => alert('Editar')}><i className="bi bi-pencil"></i> Editar</button>
                        <button className="dropdown-item delete" onClick={() => alert('Excluir')}><i className="bi bi-trash"></i> Excluir</button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="dash-card invite-card">
              <div className="invite-title">
                Link de entrada
                <button className="btn-reset-link" onClick={updateHashLink}><i className="bi bi-arrow-counterclockwise"></i></button>
              </div>
              <div className="link-box-display">{loadingResetHashLink ? <Loader /> : campaignLink}</div>
              <button className="btn-copy-link" onClick={() => { navigator.clipboard.writeText(campaignLink); window.alert("Copiado"); }}>
                <i className="bi bi-clipboard"></i> Copiar Link
              </button>
            </div>
          </div>

          {/* SEÇÃO 3D CONCISA (Somatórios) */}
          <div className="charts-grid-2col" style={{ marginBottom: '2rem' }}>
            {/* Fluxo de Leads */}
            <div className="dash-card" style={{ padding: '20px' }}>
              <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                <span style={{ fontWeight: "700", color: "#2c3e50" }}>Retenção Total (Entraram vs Sairam)</span>
              </div>
              <ReactApexChart
                type="radialBar"
                height={300}
                series={[
                  Math.round((campaignQtdMembers / (campaignQtdMembersLife || 1)) * 100),
                  Math.round(((campaignQtdMembersLife - campaignQtdMembers) / (campaignQtdMembersLife || 1)) * 100)
                ]}
                options={{
                  chart: { type: "radialBar" },
                  plotOptions: {
                    radialBar: {
                      hollow: { size: "60%" },
                      dataLabels: {
                        name: { fontSize: "14px" },
                        value: { fontSize: "18px", fontWeight: "700" },
                        total: { show: true, label: "Na Campanha", formatter: () => campaignQtdMembers }
                      }
                    }
                  },
                  colors: ["#28c76f", "#ea5455"],
                  labels: ["Ficaram", "Sairam"],
                  stroke: { lineCap: "round" }
                }}
              />
            </div>

            {/* Conversão de Acessos */}
            <div className="dash-card" style={{ padding: '20px' }}>
              <div style={{ textAlign: 'center', marginBottom: '10px' }}>
                <span style={{ fontWeight: "700", color: "#2c3e50" }}>Conversão</span>
              </div>
              <ReactApexChart
                type="bar"
                height={300}
                series={[{ name: "Quantidade", data: [campaignQtdMembersLife, qtdClicksUnique, qtdAccessLink, qtdUniqueAccessLink] }]}
                options={{
                  chart: { type: "bar", toolbar: { show: false } },
                  plotOptions: {
                    bar: { borderRadius: 8, columnWidth: "45%", distributed: true, dataLabels: { position: "top" } }
                  },
                  colors: ["#ff9f43", notifyColor],
                  xaxis: { categories: ["Entraram na campanha", "Cliques Únicos",'Acessos ao link', 'Acessos Únicos'], axisBorder: { show: false } },
                  dataLabels: { enabled: true, offsetY: -20, style: { colors: ["#333"] } },
                  fill: { type: "gradient", gradient: { shade: 'light', type: "vertical", opacityFrom: 1, opacityTo: 0.85 } }
                }}
              />
            </div>
          </div>

          {/* HISTÓRICO COM OS 4 GRÁFICOS SOLICITADOS (Entraram no grupo, Saíram, Link, Cliques) */}
          <div className="charts-grid-2col">
            {Object.keys(chartSeries).map((key) => {
              const allData = chartSeries[key].slice().sort((a, b) => new Date(a.x.split("/").reverse().join("-")) - new Date(b.x.split("/").reverse().join("-")));
              const days = daysRange[key];
              const pagedData = allData.slice(-days);

              return (
                <div key={key} className="dash-card" style={{ padding: '20px' }}>
                  <div className="chart-header">
                    <span className="chart-title" style={{ color: chartColors[key] }}>{key}</span>
                    <div className="chart-controls">
                      {PAGE_OPTIONS.map((opt) => (
                        <button key={opt} className={`btn-chart-day ${days === opt ? 'active' : ''}`} onClick={() => setDaysRange((prev) => ({ ...prev, [key]: opt }))}>
                          {opt}d
                        </button>
                      ))}
                    </div>
                  </div>
                  <ReactApexChart
                    type="area"
                    height={250}
                    series={[{ name: key, data: pagedData.map((item) => item.y) }]}
                    options={{
                      chart: { type: "area", toolbar: { show: false }, animations: { enabled: true } },
                      stroke: { curve: "smooth", width: 3 },
                      fill: { type: "gradient", gradient: { shadeIntensity: 1, opacityFrom: 0.45, opacityTo: 0.05, stops: [20, 100] } },
                      colors: [chartColors[key]],
                      xaxis: { categories: pagedData.map((item) => item.x), labels: { style: { fontSize: "11px" } } },
                      dataLabels: { enabled: false },
                      grid: { borderColor: "#f1f1f1" }
                    }}
                  />
                </div>
              );
            })}
          </div>

          {/* Configurações Finais */}
          <div className="settings-grid" style={{ marginTop: '2rem' }}>
            <div className="setting-card">
              <div className="setting-header">
                <h4>Revogação de link</h4>
                <p>Revoga o link automaticamente quando o grupo encher</p>
              </div>
              <label className="switch-label">
                <input type="checkbox" className="switch-input" checked={autoRevoke} disabled={loadingUpConfigBasis} onChange={() => updateConfig('autoRevoke', !autoRevoke)} />
                {loadingUpConfigBasis && <Loader />}
                <span className="switch-slider"></span>
              </label>
            </div>
            <div className="setting-card">
              <div className="setting-header">
                <h4>Deep Linking</h4>
                <p>Abre o WhatsApp diretamente sem a página intermediária</p>
              </div>
              <label className="switch-label">
                <input type="checkbox" className="switch-input" checked={deepLinking} disabled={loadingUpConfigBasis} onChange={() => updateConfig('deepLinking', !deepLinking)} />
                {loadingUpConfigBasis && <Loader />}
                <span className="switch-slider"></span>
              </label>
            </div>
          </div>

          <div className="settings-grid" style={{ marginBottom: '60px' }}>
            <div className="setting-card">
              <div className="setting-header">
                <h4>Cookie de redirecionamento</h4>
                <p>Mantém o lead no mesmo grupo em tentativas futuras</p>
              </div>
              <label className="switch-label">
                <input type="checkbox" className="switch-input" checked={redirectCookie} disabled={loadingUpConfigBasis} onChange={() => updateConfig('redirectCookie', !redirectCookie)} />
                {loadingUpConfigBasis && <Loader />}
                <span className="switch-slider"></span>
              </label>
            </div>
            <div className="setting-card">
              <div className="setting-header">
                <h4>Anti-Hacker</h4>
                <p>Proteção ativa contra mensagens indesejadas</p>
              </div>
              <label className="switch-label">
                <input type="checkbox" className="switch-input" checked={antiHacker} disabled={loadingUpConfigBasis} onChange={() => updateConfig('antiHacker', !antiHacker)} />
                {loadingUpConfigBasis && <Loader />}
                <span className="switch-slider"></span>
              </label>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Dashcampanha;